import React, { useEffect, useState, useRef } from 'react'
import ReferralReturnSlip from './helper/ReferralOutSlip'
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS } from '../../utils/constants';
import ReferredOutSlip from './helper/ReferredReturnSlip';
import ReactToPrint from 'react-to-print';
import { Box, IconButton } from "@mui/material";
import { Print } from "@mui/icons-material";
import AHMIS, { API_URL } from "../../api/api";
import AddAlertMessage from "../alert/Alert";
import { AppUtils } from "../../utils/appUtils";

const ReferralSlip = () => {
  const id = AppUtils.getUrlParam("id");
  const [patientDetails, setpatientDetails] = useState([]);
  const printComponentRef = useRef();

  const getPatientReferralDetails = () => {
    let url = `${API_URL.outPatient}/${id}`;
    AHMIS.get(url).then((response) => {
      let jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setpatientDetails(jsondata.data)
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message })
      }
    })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  useEffect(() => {
    getPatientReferralDetails()
  }, [])


  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"} margin={3}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => printComponentRef.current}
      />

      <ReferredOutSlip
        patientData={patientDetails}
        printComponentRef={printComponentRef}
      />
      <ReferralReturnSlip
        patientData={patientDetails}
        printComponentRef={printComponentRef}
      />
    </>
  )
}

export default ReferralSlip
